"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
class DateInputValidator {
  validatePattern = value => {
    const regexPattern = /^\d{1,2}\.\d{1,2}\.\d{4}$/;
    if (!regexPattern.test(value)) {
      return false;
    }
    const isZeroLeading = string => {
      return string.substring(0, 1) === '0';
    };
    const split = value.split('.');
    const dayString = split[0];
    const monthString = split[1];
    const isDayTooHigh = Number(dayString) > 31;
    const isMonthTooHigh = Number(monthString) > 12;
    if (isDayTooHigh || isMonthTooHigh || isZeroLeading(dayString) || isZeroLeading(monthString)) {
      return false;
    }
    return true;
  };
}
const dateInputValidator = new DateInputValidator();
var _default = exports.default = dateInputValidator;